import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface UserCardOpenProps {
  isCursor: boolean | undefined;
}

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 19px;
`;

export const UserCardClose = styled.div`
  margin: 4px 0;
  height: 40px;
  display: flex;
  flex-direction: row;
  border-radius: 12px;
  border: solid 1px ${ColorPalette.HEX.BrightGray7};
  background-color: ${ColorPalette.HEX.White};
  align-items: center;
`;

export const CloseName = styled.label`
  padding: 0;
  margin-left: 8px;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const UserCardOpen = styled.div<UserCardOpenProps>`
  ${(props: UserCardOpenProps) => (props.isCursor ? 'cursor: pointer;' : '')}

  label {
    ${(props: UserCardOpenProps) => (props.isCursor ? 'cursor: pointer;' : '')}
  }

  margin: 4px 0;
  height: 80px;
  border-radius: 12px;
  border: solid 1px ${ColorPalette.HEX.BrightGray7};
  background-color: ${ColorPalette.HEX.White};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const UserCardOpenContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

export const OpenName = styled.label`
  padding: 0;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Email = styled.label`
  padding: 0;
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.DimGray};
`;

export const CurrentIcon = styled.div`
  height: 56px;
  width: 56px;
  border-radius: 50%;
  background: ${ColorPalette.HEX.OutrageousOrange};
  margin-left: auto;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  -webkit-animation: fadeinout 1.8s linear forwards;
  animation: fadeinout 1.6s linear forwards;

  @-webkit-keyframes fadeinout {
    0%,
    100% {
      opacity: 0;
    }
    30% {
      opacity: 1;
    }
    40% {
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    70% {
      opacity: 1;
    }
  }

  @keyframes fadeinout {
    0%,
    100% {
      opacity: 0;
    }
    35% {
      opacity: 1;
    }
    40% {
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    70% {
      opacity: 1;
    }
  }
`;
